/**
 * variable f. screenreader/ tab focus nach Schliessung Modal/ popup
 */
var lastClickedItemToFocusOn;

/**
 * Alias für window.open
 * 
 * @param {string}  link            URL die geöffnet werden soll
 * @param {string}  [ausfuehrung]   Window Object Features
 */
function popup( link, ausfuehrung ) {
  window.open( link, "INFO", ausfuehrung );
}

/**
 * Form Daten ermitteln
 * 
 * Ermittelt Formular-Daten für einen übergebenen Selektor. Es werden dabei alle <input> Felder 
 * Berücksichtigt die ein `name`-Attribut besitzen und somit indexiert werden können
 */
function getFormData( selector ) { 
  var data = {};

  // Sanity check
  if ( !$(selector).length ) return;

  $(selector).find('input, textarea, .selectpicker').each( function(){ 
    if ( typeof this.name == 'undefined' || !this.name.length ) return true;

    if ( this.type == 'radio' || this.type == 'checkbox' ) { 
      if ( this.checked ) data[this.name] = this.value;
    } else { 
      data[this.name] = this.value;
    }
  })
  return data;
}

/**
 *  Radio-Elemente werden aktiviert/ deaktiviert
 */
function checkradio(strName, strDiv, strDiv2) {
  if ( document.getElementById(strName) ) {
    if ( document.getElementById(strName).checked == true) {
    document.getElementById(strDiv).style.display='';
    if ( document.getElementById(strDiv2) ) {
    document.getElementById(strDiv2).style.display='none';
    }
    } else {
    document.getElementById(strDiv).style.display='none';
    if ( document.getElementById(strDiv2) ) {
    document.getElementById(strDiv2).style.display='';
    }
    }
  }
}

$(document).on("keydown", "#page-content-skip, #page-content-skip a",  function(e) {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    $('.page-content').find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').eq(0).focus();
  }
});

$(document).on("click", "#page-content-skip, #page-content-skip a",  function(e) {
  e.preventDefault();
  $('.page-content').find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').eq(0).focus();
});

class RadioGroup {
  constructor(groupNode) {
    this.groupNode = groupNode;

    this.radioButtons = [];

    this.firstRadioButton = null;
    this.lastRadioButton = null;

    var rbs = this.groupNode.querySelectorAll('input[type="radio"]');

    for (var i = 0; i < rbs.length; i++) {
      var rb = rbs[i];
      
      rb.tabIndex = -1;
      rb.setAttribute('aria-checked', 'false');
      rb.checked = false;
      rb.addEventListener('keydown', this.handleKeydown.bind(this));
      rb.addEventListener('click', this.handleClick.bind(this));
      rb.addEventListener('focus', this.handleFocus.bind(this));
      rb.addEventListener('blur', this.handleBlur.bind(this));

      this.radioButtons.push(rb);

      if (!this.firstRadioButton) {
        this.firstRadioButton = rb;
      }
      this.lastRadioButton = rb;
    }
    this.firstRadioButton.tabIndex = 0;
  }

  setChecked(currentItem) {
    for (var i = 0; i < this.radioButtons.length; i++) {
      var rb = this.radioButtons[i];
      rb.setAttribute('aria-checked', 'false');
      rb.checked = false;
      rb.tabIndex = -1;
    }
    currentItem.setAttribute('aria-checked', 'true');
    currentItem.checked = true;
    currentItem.tabIndex = 0;
    currentItem.focus();
  }

  setCheckedToPreviousItem(currentItem) {
    var index;

    if (currentItem === this.firstRadioButton) {
      this.setChecked(this.lastRadioButton);
    } else {
      index = this.radioButtons.indexOf(currentItem);
      this.setChecked(this.radioButtons[index - 1]);
    }
  }

  setCheckedToNextItem(currentItem) {
    var index;

    if (currentItem === this.lastRadioButton) {
      this.setChecked(this.firstRadioButton);
    } else {
      index = this.radioButtons.indexOf(currentItem);
      this.setChecked(this.radioButtons[index + 1]);
    }
  }

  /* EVENT HANDLERS */

  handleKeydown(event) {
    var tgt = event.currentTarget,
      flag = false;

    switch (event.key) {
      case ' ':
      case 'Enter':
        this.setChecked(tgt);
        flag = true;
        break;

      case 'Up':
      case 'ArrowUp':
      case 'Left':
      case 'ArrowLeft':
        this.setCheckedToPreviousItem(tgt);
        flag = true;
        break;

      case 'Down':
      case 'ArrowDown':
      case 'Right':
      case 'ArrowRight':
        this.setCheckedToNextItem(tgt);
        flag = true;
        break;

      default:
        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  handleClick(event) {
    this.setChecked(event.currentTarget);
  }

  handleFocus(event) {
    event.currentTarget.classList.add('focus');
  }

  handleBlur(event) {
    event.currentTarget.classList.remove('focus');
  }
}

function focusAndTrapInContainer( containerId ) {
  var focusableElements = 'button:not(:disabled), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  var container = document.querySelector(containerId);

  var firstFocusableElement = container.querySelectorAll(focusableElements)[0];
  var focusableContent = container.querySelectorAll(focusableElements);
  var lastFocusableElement = focusableContent[focusableContent.length - 1];

  firstFocusableElement.focus();
  
  container.addEventListener('keydown', function(e) {

    focusableElements = 'button:not(:disabled), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    firstFocusableElement = container.querySelectorAll(focusableElements)[0];
    focusableContent = container.querySelectorAll(focusableElements);
    lastFocusableElement = focusableContent[focusableContent.length - 1];
    

    var isTabPressed = e.key === 'Tab';

    if (!isTabPressed) {  
      return;
    }

    if (e.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault();
      }
    } else { // if tab key is pressed
      if (document.activeElement === lastFocusableElement) { 
        firstFocusableElement.focus();
        e.preventDefault();
      }
    }
  });

}

function setCookieEm(cname, cvalue, exdays) {
  const d = new Date();

  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  var domain = '.' + window.location.host.split('.').splice( -2 ).join('.');
  document.cookie = cname + "=" + cvalue + ";secure;SameSite=None;" + expires + "; domain="+domain+"; path=/";
}

function getCookieEm(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


$(document).on( 'init reInit', '.pb-slider', (e, slick) => {
  if (false === slick.options?.autoplay || false) {
    return true;
  }
  // Dynamic Event Listener for Pause/play and insert markup
  $(e.target).prepend(`
    <div class='slick-autoplay-toggle-button' aria-label='slider ein- und ausschalten' tabindex='0'>
      <i class='fa fa-pause' aria-hidden='true'></i>
    </div>
  `);
  
  $(e.target).on('click', '.slick-autoplay-toggle-button', (e) => {
      let slider = e.delegateTarget || e.target
      let slick = slider.slick || {}

      if (typeof slick == 'undefined') return

      slick.paused ? slick.slickPlay() : slick.slickPause()

      $(slider).find('.slick-autoplay-toggle-button > i.fa').toggleClass('fa-play').toggleClass('fa-pause')
  })

  // if slider gets destroyed, remove btn and disable btn events
  $(e.target).one('destroy', e => {
    $(e.target).off('click', '.slick-autoplay-toogle-button');
    $(e.target).find('.slick-autoplay-toggle-button').remove()
  })
});
 
